module.exports = __webpack_public_path__ + "img/Superrent_App_Mockup_01.a71e9ca2.png";